<template>
  <v-row class="text--primary" v-if="itemAprovacao.niveis && itemAprovacao.niveis.length">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Aprovadores
        </v-subheader>
        <v-divider/>
        <v-list dense v-for="(nivel, index) in itemAprovacao.niveis" :key="index">
          <v-subheader class="ml-2 font-weight-bold body-1"># {{ index + 1 }}</v-subheader>
          <small class="ml-6">*&nbsp;{{ requerAprovacaoLabel(nivel)}}</small>
          <v-list-item
            v-for="(aprovador, i) in nivel.aprovadores"
            :key="i"
            color="primary"
            variant="plain"
            class="ml-3"
          >
            <v-list-item-title>
              {{ aprovador.gestor.nome }}
              <px-situacao-aprovacao class="ml-3" :situacao="aprovador.situacao"/>
              <span v-if="aprovador.dataAprovacao">
                em {{ aprovador.dataAprovacao | date(true) }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    requerAprovacaoLabel() {
      return nivel => (nivel.requerAprovacaoTotal ? 'Requer aprovação de todos os aprovadores' : 'Requer aprovação de ao menos um aprovador');
    },
  },
};
</script>
